import { useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Routes from 'ContentUtils/Routes';
import { getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getHasUnsavedChanges } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
// @ts-expect-error not typed
import EditorActionsAndEventsContext from 'ContentEditorUI/context/EditorActionsAndEventsContext';
import { getIsInDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
// @ts-expect-error not typed
import { closeModal } from 'ContentEditorUI/redux/actions/appActions';
// @ts-expect-error not typed
import { getIdForOpenConfirmEditEmbedModal } from 'ContentEditorUI/redux/selectors/globalContentSelectors';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EmbedModal({
  fromAppName
}) {
  const [waitingForSave, setWaitingForSave] = useState(false);
  const selectedEmbedId = useSelector(getIdForOpenConfirmEditEmbedModal);
  const contentId = useSelector(getContentModelId);
  const hasUnsavedChanges = useSelector(getHasUnsavedChanges);
  const isInDefaultBreakpointMode = useSelector(getIsInDefaultBreakpointMode);
  const {
    saveActions
  } = useContext(EditorActionsAndEventsContext);
  const dispatch = useDispatch();
  const handleConfirm = () => {
    const seleniumRunning = window.SELENIUM_IS_RUNNING ? true : undefined;
    const newLocation = Routes.contentEmbedEditor(selectedEmbedId, {
      contentId,
      seleniumRunning,
      redirectUrl: window.location.pathname,
      fromAppName
    });
    if (hasUnsavedChanges) {
      setWaitingForSave(true);
      saveActions.autoSave().then(() => {
        window.location.href = newLocation;
      }).catch(err => {
        console.error(err);
      });
    } else {
      window.location.href = newLocation;
    }
  };
  function onClose() {
    dispatch(closeModal());
  }
  const description = isInDefaultBreakpointMode ? 'components.modals.globalContentModal.descriptionDesktop' : 'components.modals.globalContentModal.descriptionMobile';
  if (selectedEmbedId) {
    return /*#__PURE__*/_jsx(ConfirmModal, {
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "components.modals.embedModal.title"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: description
      }),
      ConfirmButton: LoadingButton,
      onConfirm: handleConfirm,
      rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "components.modals.globalContentModal.rejectLabel"
      }),
      confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "components.modals.embedModal.confirmLabel"
      }),
      onReject: onClose,
      size: "auto",
      confirmButtonProps: {
        loading: waitingForSave,
        use: 'primary'
      }
    });
  }
  return null;
}